const PLACEHOLDER = /Historical Figure \d+/i;

/** Drop placeholder / stub records and exact title+year duplicates. */
export const cleanEvents = (list) => (list || []).filter((e) => {
  const title = e.event_title || "";
  const desc = e.description_long || e.description || "";
  if (PLACEHOLDER.test(title) || PLACEHOLDER.test(desc) || title.startsWith("Birth of Historical Figure")) return false;
  if (desc.includes("Notable figure known for contribution to music") && desc.length < 80) return false;
  return true;
}).filter((e, i, arr) => arr.findIndex((o) => o.event_title === e.event_title && String(o.year) === String(e.year)) === i);

export const personName = (t) => (t || "").replace(/^(Birth|Death) of /i, "").replace(/\s+(born|dies|died|is born)$/i, "").trim();

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const ddmmLabel = (ddmm) => {
  const [d, m] = String(ddmm || "").split("-").map(Number);
  return d && m ? `${d} ${MONTHS[m - 1]}` : "";
};

export const setSeo = ({ title, description, canonical }) => {
  if (title) document.title = title;
  if (description) {
    let el = document.querySelector('meta[name="description"]');
    if (!el) { el = document.createElement("meta"); el.setAttribute("name", "description"); document.head.appendChild(el); }
    el.setAttribute("content", description);
  }
  if (canonical) {
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
    el.setAttribute("href", canonical);
  }
};
